import { Menu } from "@/types";
import { atom } from "jotai";

const indoorMenuAtom = atom<Menu | null>(null);

export default indoorMenuAtom;
